<template>
	<v-card class="rounded-lg filter-card">
		<h1>Filtros</h1>
		<div class="filter-element">
			<h3 class="filter-label">Categorías</h3>

			<v-combobox
				label="Seleccione categrías"
				class="category-autocomplete"
				v-model="localFilter.tags"
				:items="existingTags"
				multiple
				@change="filterChanged"
				chips
				:search-input.sync="searchInput"
			>
			</v-combobox>
		</div>
		<div class="filter-element">
			<h3 class="filter-label">Distancia</h3>
			<v-range-slider
				aria-label="distance slider"
				v-model="localFilter.range"
				max="200"
				thumb-label
				color="accent"
				@click="filterChanged"
				@mouseup="filterChanged"
			>
				<template #append>
					<p class="km-append">km</p>
				</template>
			</v-range-slider>
		</div>
		<div class="filter-element">
			<h3 class="filter-label other">Otros</h3>
			<v-switch
				class="switch"
				label="Sin comenzar"
				v-model="localFilter.notStarted"
				inset
				color="accent"
				@change="filterChanged"
			></v-switch>
			<v-switch
				class="switch"
				label="Terminadas"
				v-model="localFilter.finished"
				inset
				color="accent"
				@change="filterChanged"
			></v-switch>
			<v-switch
				class="switch"
				label="Solo gratis"
				v-model="localFilter.free"
				inset
				color="accent"
				@change="filterChanged"
			></v-switch>
		</div>
	</v-card>
</template>

<script>
	import axios from "axios";
	export default {
		props: {
			filter: Object,
		},
		data() {
			return {
				localFilter: { ...this.filter },
				existingTags: [],
				searchInput: "",
			};
		},
		methods: {
			filterChanged() {
				this.$emit("filterChanged", {
					filter: { ...this.localFilter },
				});
				this.searchInput = "";
			},
			async fetchExistingTags() {
				try {
					const response = await axios.get("/races/tags");
					this.existingTags = response.data;
				} catch (error) {
					//Not a problem but avoid the exception
				}
			},
		},
		mounted() {
			this.fetchExistingTags();
		},
	};
</script>

<style lang="scss" scoped>
	.filter-card {
		min-height: 40vh;
		padding: 2em;
		display: flex;
		flex-direction: column;
		background-color: #f9f9f9;

		.filter-element {
			display: flex;
			flex-direction: column;

			flex: 1;

			.filter-label {
				margin: 0;

				.other {
					margin-bottom: 1em;
				}
			}

			.category-autocomplete {
				margin-top: 1em;
				padding-top: 0;
			}

			.km-append {
				margin-top: 3px;
			}

			.switch {
				margin: 0;
			}
		}
	}
</style>
